import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { useGet, usePost } from "seed/api";
import { useDetail } from "seed/gql";
import { useUserUsage } from "components/util/helpers/UserUsage";
import l from "components/util/l";
import View from "components/presentation/settings/Settings.view";
import { Loading } from "seed/helpers";

function ChatSettings({
  flow,
  chat,
  isAdmin,
  refreshFlow,
  refreshChat
}) {
  const userId = sessionStorage.getItem("id");
  const isDeveloper = sessionStorage.getItem("is_developer") == "true";
  const { userUsage } = useUserUsage();
  const [permissionTabSelected, setPermissionTabSelected] = useState("GENERAL");


  const reqFlow = useGet(`/flows/get_settings`, { flow_id: flow.id });
  const reqUser = useDetail(`{  user { accountSettings }  }`, userId)

  const [callSet] = usePost("/flows/set_settings", {
    onCompleted: (data) => {
      if (data.token != flow.token) window.location.href = "/app/" + data.token;
      swal(l("Guardado%PA084"), l("Cambios guardados%PA085"), "success");
      refreshChat();
    },
    onError: (error) => {
      if (error.status == 409)
        swal("Error", l("El token ingresado ya está en uso%PA086"), "error");
      else
        swal("Error", l("Ocurrió un error inesperado%PA087"), "error");
    },
  });

  useEffect(() => {
    reqFlow.refetch();
    reqUser.refetch();
  }, []);


  if (reqFlow.loading || reqUser.loading)
    return <div className="w-100 h-75"><Loading /></div>


  const onClickConfiguration = () =>
    window.location.href = "/app/settings/customization";

  const onSubmit = (values) => {

    values.presentation_settings = {
      ...values.presentation_settings ?? {},
      theme: {
        primaryColor: values.primaryColor,
        accentColor: values.accentColor,
        logo: values.logo
      },
    };

    callSet({ 
      flow_id: flow.id, 
      chat_id: chat.id,
      settings: values 
    });

  }
  const {
    chat_settings: chatSettings = {},
    presentation_settings: presentationSettings = {},
    security_settings: securitySettings = {},
    flow_node_permissions: flowNodePermissions = [],
    collection_permissions: collectionPermissions = []
  } = reqFlow.data;


  const { user } = reqUser.data

  return <View
    user={user}
    flow={flow}
    chat={chat}
    userUsage={userUsage}
    chatSettings={chatSettings}
    presentationSettings={presentationSettings}
    securitySettings={securitySettings}
    flowNodePermissions={flowNodePermissions}
    collectionPermissions={collectionPermissions}
    permissionTabSelected={permissionTabSelected}
    isDeveloper={isDeveloper}
    isAdmin={isAdmin}
    refreshFlow={refreshFlow}
    onClickConfiguration={onClickConfiguration}
    onSubmit={onSubmit}
    setPermissionTabSelected={setPermissionTabSelected}
  />;

}

export default ChatSettings;